import { FormBuilder, FormControl } from '@angular/forms';
import { mustNotBeBlankValidator, SetInitialStateFacade } from '../../../../../common';
import { Observable } from 'rxjs';

export interface DataQualityMessagesRawError {
  segment: string;
  errors: string[];
}

export interface DataQualityErrorMessage {
  rawMessageParsingErrors: DataQualityMessagesRawError[] | null;
  internalValidationErrors: string[] | null;
}

export interface MessageCheckerStateModel {
  errorMessages: DataQualityErrorMessage;
  loaded: boolean;
}

export interface MessageCheckerFacade extends SetInitialStateFacade {
  errorMessages$: Observable<DataQualityErrorMessage>;
  loaded$: Observable<boolean>;
  checkMessage(message: string): void;
}

export class MessageCheckerForm {
  constructor(
    fb: FormBuilder = new FormBuilder(),
    public message: FormControl<string> = fb.control<string>('', [mustNotBeBlankValidator]),
  ) {}
}
